/*
 * @Author: cc
 * @Date: 2015-12-18
 * @LastEditTime: 2021-04-23 18:22:40
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\btnFilterService\btnFilerService.js
 * @Description: 权限按钮过滤
 */
'use strict';

angular.module('editctrFilterBtnModule', []).factory('filterEditctrBtnsService', ['trsHttpService', '$q', function(trsHttpService, $q) {
    return {
        filterBtn: function(initBtnArrays, dictionaryArrays) {
            var i = 0;
            // var deferred = $q.defer();
            var arrayBtn = [];
            while (i < dictionaryArrays.length) {
                angular.forEach(initBtnArrays, function(value, key) {
                    // console.log(value.OPERDESC+"=="+key)
                    // console.log(dictionaryArrays[i].OPERDESC)
                    // console.log(dictionaryArrays[i].authorityName)
                    if (value.OPERDESC === dictionaryArrays[i].OPERDESC || dictionaryArrays[i].authorityName == value) {
                        // console.log("SUCCESS:"+dictionaryArrays[i].OPERDESC)
                        arrayBtn.push(dictionaryArrays[i]);
                    }
                    if(value.OPERDESC == "部门提交" && dictionaryArrays[i].OPERDESC == "送审"){
                        arrayBtn.push(dictionaryArrays[i]);
                    }
                });
                i++;

            }
            return arrayBtn;
        }
    };
}]);
